import { Component } from "react"
import PropTypes from "prop-types"
import { TextField, InputAdornment } from "@mui/material"
import { DEFAULT_CURRENCY } from "helpers/formatters/numbers"

export default class SingleValueFilter extends Component {
  static propTypes = {
    values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
    dataType: PropTypes.string.isRequired,
    setValues: PropTypes.func.isRequired,
    currency: PropTypes.string,
    disabled: PropTypes.bool,
  }

  setValue = e => {
    const { setValues } = this.props
    setValues(e.target.value)
  }

  render() {
    const { values, dataType, currency, disabled } = this.props
    let adornment = null
    let endAdornment = null
    let endAdornmentValue = null
    switch (dataType) {
      case "percent":
        adornment = <InputAdornment position="start">%</InputAdornment>
        break
      case "millions":
        endAdornmentValue = "M"
        if (!currency || currency === DEFAULT_CURRENCY) {
          adornment = <InputAdornment position="start">$</InputAdornment>
        } else {
          endAdornmentValue += ` ${currency}`
        }

        endAdornment = <InputAdornment position="end">{endAdornmentValue}</InputAdornment>
        break
    }

    return <TextField
      variant="standard"
      className="value"
      value={values[0] === undefined ? "" : values[0]}
      onChange={this.setValue}
      disabled={disabled}
      slotProps={{
        input: { startAdornment: adornment, endAdornment },
      }}
    />
  }
}
